import { connect } from 'react-redux';

import PDFViewer from './PDFViewer';

const mapStateToProps = ({ auth }) => ({ token: auth.token });

export default connect(mapStateToProps, null)(PDFViewer);
